<template>
  <div :id="printerId || 'printerDiv'">

    <div v-for="i in (localCopyCount || printCopyCount || 1)" :key="i" class="pr-container" :class="{'pr-page-break': i < (localCopyCount || printCopyCount || 1)}">
      <div class="pr-header">
        <div class="pr-branch">{{ companyName || 'BREW MOOD' }}</div>
        <div v-if="getBranchName" class="pr-sub-branch">{{ getBranchName }}</div>
        <div class="pr-meta">
          <span>Fiş No: {{ localBillNo || billNo || billId }}</span>
          <span v-if="(localBillNo || billNo || billId) && (localActivePersonal || activePersonal)">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span v-if="localActivePersonal || activePersonal">Personel: {{ localActivePersonal || activePersonal }}</span>
        </div>
      </div>

    
    <div class="pr-sep"></div>

    <table class="pr-tbl">
      <thead>
        <tr>
          <th class="pr-th pr-al pr-c-name">Ürün</th>
          <th class="pr-th pr-ac pr-c-qty">Miktar</th>
          <th class="pr-th pr-ar pr-c-price">Tutar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="entry in (localOrderEntries || orderEntries)" :key="entry.id" class="pr-item-row">
          <td class="pr-td pr-al pr-c-name">
            <span class="pr-product-name">{{ cleanProductName(entry.productName) }}</span>
            <span v-for="variant in entry.variantItems" :key="'v'+variant.id" class="pr-sub pr-block">* {{ variant.name }}</span>
            <div v-if="(entry.steps || entry.Steps || entry.recipeSteps || entry.RecipeSteps) || (entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.RecipeSteps))">
              <div
                v-for="(step, sIdx) in ((entry.steps || entry.Steps || entry.recipeSteps || entry.RecipeSteps) || (entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.RecipeSteps)) || []).filter(x => (x.isRemoved || x.IsRemoved || x.selected || x.Selected) && (x.name || x.Name))"
                :key="'step-' + (entry.id || entry.productId) + '-' + (step.id || step.index || sIdx)"
                class="pr-sub pr-block"
                :class="{'pr-line-through': step.isRemoved || step.IsRemoved}"
              >
                {{ (step.isRemoved || step.IsRemoved) ? '-' : '*' }} {{ (step.name || step.Name || '').trim() }}
              </div>
            </div>
            <template v-for="extra in (entry.extras || entry.Extras || [])">
              <span v-if="(parseFloat(extra.quantity || extra.Quantity || 0)) > 0 && (!(extra.variants || extra.Variants) || (extra.variants || extra.Variants).length === 0)" :key="'e'+extra.id" class="pr-sub pr-block">
                + {{ extra.name || extra.Name }} (x{{ extra.quantity || extra.Quantity }})
              </span>
              <template v-else-if="(extra.variants || extra.Variants) && (extra.variants || extra.Variants).length > 0">
                <span v-for="variant in (extra.variants || extra.Variants).filter(v => (parseFloat(v.quantity || v.Quantity || 0)) > 0)" :key="'ev'+variant.id" class="pr-sub pr-block">
                  + {{ variant.name || variant.Name }} (x{{ variant.quantity || variant.Quantity }})
                </span>
              </template>
            </template>
            <div v-if="entry.description" class="pr-sub pr-block" style="white-space: pre-line;">
              {{ entry.description }}
            </div>
            <span v-if="entry.note" class="pr-note pr-block">Not: {{ entry.note }}</span>
          </td>
          <td class="pr-td pr-ac pr-c-qty">
            <span v-if="((entry.lastStartTime || entry.LastStartTime || entry.startTime || entry.StartTime) && (entry.lastStopTime || entry.LastStopTime || entry.endTime || entry.EndTime)) || (entry.totalHour || entry.TotalHour || entry.TimeHour)" class="pr-qty-badge">{{ formatTimeForPrint(entry) }}</span>
            <span v-else class="pr-qty-badge">x{{ entry.productQuantity || entry.quantity || entry.Quantity || 1 }}</span>
          </td>
          <td class="pr-td pr-ar pr-c-price pr-price-cell">
            <template v-if="(Number(entry.originPrice) || 0) > (Number(entry.price) || 0)">
              <div class="pr-old-price">{{ $toCurrency(entry.originPrice) }}</div>
              <div class="pr-net-price">{{ $toCurrency(entry.price) }}</div>
            </template>
            <template v-else>
              {{ $toCurrency(entry.price) }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pr-sep pr-sep-thick"></div>
    <table class="pr-ftr-tbl">
      <tr class="pr-ftr-gross">
        <td class="pr-ftr-lbl">Ara Toplam:</td>
        <td class="pr-ftr-val">{{ $toCurrency(localTotalOriginPrice || 0) }}</td>
      </tr>
      <tr v-if="(localTotalDiscountPrice || 0) > 0" class="pr-discount">
        <td class="pr-ftr-lbl">İndirim Toplamı:</td>
        <td class="pr-ftr-val">-{{ $toCurrency(localTotalDiscountPrice || 0) }}</td>
      </tr>
      <tr class="pr-ftr-net">
        <td class="pr-ftr-lbl">Ödenen Toplam:</td>
        <td class="pr-ftr-val">{{ $toCurrency(localTotalPayedPrice || 0) }}</td>
      </tr>
    </table>
    
    <!-- v118.V31: Kalan Tutar ve Masa Durumu (Popup ile Senkron) -->
    <div v-if="!(localIsFinal !== null ? localIsFinal : isFinal)" class="pr-balance-container">
      <div class="pr-sep pr-sep-thin"></div>
      <div v-if="(localLeftPrice !== null ? localLeftPrice : leftPrice) > 0" class="pr-balance-row">
        <span class="pr-balance-lbl">KALAN TUTAR:</span>
        <span class="pr-balance-val text-danger">{{ $toCurrency(localLeftPrice !== null ? localLeftPrice : leftPrice) }}</span>
      </div>
      <div v-else class="pr-thanks">
       Bizi Tercih Ettiğiniz İçin Teşekkür Ederiz.
      </div>
    </div>

    <div class="pr-sep pr-sep-thin"></div>
    <div v-if="localIsFinal !== null ? localIsFinal : isFinal" class="pr-thanks"></div>
    </div>
  </div>
</template>


<script src="https://www.google.com/cloudprint/client/cpgadget.js"/>
<script>
import companyInfo from "../../../model/constants/companyInfo";
import printJS from "print-js";
import { getOrderEntries, getOrderLogs, getOrderBySID, triggerKitchenPrintBySID, markAdisyonPrinted } from "@/api/Cart";

// YAZICI İÇİN KULLANILACAK CSS (scanStyles: false ile global CSS'den etkilenmez)
const PRINT_CSS = `
  @page { size: 80mm auto; margin: 0; }
  body { margin: 0; padding: 0; background: #fff; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; }
  .pr-container { width: 80mm; padding: 10pt 6pt; box-sizing: border-box; color: #000; background: #fff; }
  
  .pr-header { text-align: center; margin-bottom: 8pt; }
  .pr-branch { font-size: 12pt !important; font-weight: 900; margin-bottom: 2pt; text-transform: uppercase; letter-spacing: 0.5pt; }
  .pr-sub-branch { font-size: 10pt !important; font-weight: bold; margin-bottom: 4pt; text-transform: uppercase; }
  .pr-meta { font-size: 9pt !important; line-height: 1.5; color: #000; }
  .pr-meta-user { margin-top: 2pt; font-size: 9pt !important; color: #000; }
  
  .pr-sep { border: 0; border-top: 1.5px dashed #000; margin: 4pt 0; display: block; }
  .pr-sep-thick { border-top: 2px solid #000 !important; margin-top: 2pt; margin-bottom: 4pt; }
  .pr-sep-thin { border-top: 1px solid #000 !important; margin-top: 4pt; margin-bottom: 4pt; }
  
  .pr-tbl { width: 100%; border-collapse: collapse; table-layout: fixed; margin-bottom: 4pt; }
  .pr-c-name { width: 58%; }
  .pr-c-qty { width: 17%; }
  .pr-c-price { width: 25%; }
  
  .pr-al { text-align: left; }
  .pr-ac { text-align: center; }
  .pr-ar { text-align: right; }
  
  .pr-th { font-size: 9pt !important; font-weight: bold; padding: 2pt 0 4pt; border-bottom: 1.5px solid #000; }
  .pr-td { vertical-align: middle; padding: 5pt 0; word-break: break-word; }
  
  .pr-item-row { border-bottom: 1px dashed #bbb; }
  .pr-item-row:last-child { border-bottom: none; }
  
  .pr-product-name { font-size: 9.5pt !important; font-weight: bold; display: block; }
  .pr-old-price { font-size: 8pt; color: #666; text-decoration: line-through; }
  .pr-net-price { font-size: 10pt; font-weight: bold; }
  .pr-block { display: block; }
  .pr-sub { font-size: 7.5pt !important; color: #000; padding-left: 3pt; margin-top: 1.5pt; }
  .pr-note { font-size: 7.5pt !important; font-style: italic; color: #000; margin-top: 1.5pt; font-weight: bold; }
  
  .pr-qty-badge { font-weight: bold; font-size: 9.5pt !important; }
  .pr-price-cell { font-weight: 900; font-size: 10pt !important; white-space: nowrap; }
  
  /* Bilgi (Act) SÃ¼tunu DÃ¼zenlemeleri */
  .pr-act-txt { font-size: 8pt !important; display: block; line-height: 1.3; color: #222; text-align: right; }
  .pr-act-name { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: bold; }
  .pr-act-date { white-space: nowrap; color: #000; }
  
  .pr-footer { padding: 2pt 0; }
  .pr-ftr-tbl { width: 100%; border-collapse: collapse; }
  .pr-ftr-lbl { font-size: 10pt !important; font-weight: bold; text-align: left; padding: 2pt 0; white-space: nowrap; width: 50%; }
  .pr-ftr-val { font-size: 10pt !important; font-weight: bold; text-align: right; padding: 2pt 0; }
  .pr-ftr-net { border-top: 1.5px solid #000; }
  .pr-ftr-net .pr-ftr-lbl { font-size: 12pt !important; font-weight: 900; padding-top: 4pt; }
  .pr-ftr-net .pr-ftr-val { font-size: 13pt !important; font-weight: 900; padding-top: 4pt; }
  .pr-discount { color: #000; }
  
  .pr-thanks { text-align: center; font-size: 9pt !important; padding: 6pt 0 2pt; line-height: 1.6; font-weight: bold; }
  .pr-line-through { text-decoration: line-through !important; }
  .pr-page-break { page-break-after: always; }

  /* v118.V31: Bakiye ve Durum Tasarımı */
  .pr-balance-container { margin-top: 4pt; }
  .pr-balance-row { display: flex; justify-content: space-between; align-items: center; padding: 4pt 0; }
  .pr-balance-lbl { font-size: 11pt !important; font-weight: 900; color: #000; }
  .pr-balance-val { font-size: 13pt !important; font-weight: 900; }
  .pr-closed-banner { text-align: center; font-size: 11pt !important; font-weight: 900; padding: 6pt 0; border: 1.5px solid #000; margin-top: 4pt; letter-spacing: 1pt; }
  .text-danger { color: #000 !important; } /* Siyah beyaz yazÄ±cÄ± uyumu */
`;


export default {
  props: {
    totalPrice:         { type: Number, required: false },
    totalDiscountPrice: { type: Number, required: false },
    orderEntries:       { type: Array,  required: false },
    currentDateTime:    { type: String, required: false },
    activePersonal:     { type: String, required: false },
    billNo:             { type: Number, required: false },
    tableName:          { type: String, required: false },
    branchName:         { type: String, required: false },
    totalOriginPrice:   { type: Number, required: false },
    leftPrice:          { type: Number, required: false },
    printerId:          { type: String, required: false, default: 'printerDiv' },
    printCopyCount:     { type: Number, required: false, default: 1 },
    isFinal:            { type: Boolean,required: false, default: false },
    connection:         { type: Object, required: false, default: null },
    orderPayments:      { type: Array,  required: false, default: () => [] }
  },

  watch: {
    // Agresif watch mekanizması kaldırıldı. Sepet temizliği sırasında veriyi vaktinden önce sıfırlıyordu.
    // Sıfırlama artık fetchAndPrint ve setOrderAndPrint metodlarının başında manuel yapılıyor.
  },
  data() {
    return { 
      companyName: companyInfo.name,
      localOrderEntries: null,
      localTotalPrice: null,
      localTotalOriginPrice: null,
      localTotalDiscountPrice: null,
      localBillNo: null,
      localTableName: null,
      localActivePersonal: null,
      localBranchName: null,
      localCopyCount: null,
      localIsFinal: null,
      localTotalPayedPrice: null,
      localLeftPrice: null,
      localOrderPayments: null,
      isLoading: false
    }

  },
  computed: {
    billId() {
      return this.$store.getters["selfservice/getToLastBillId"];
    },
    printerSettings() {
      return this.$store.getters["selfservice/getPrinterSettings"];
    },
    branchLabel() {
      if (this.branchName) return this.branchName;
      const user = this.$store.getters["getActiveUser"];
      if (user && user.userBranch && user.userBranch !== 'Merkez') return user.userBranch;
      return this.companyName;
    },
    getBranchName() {
      if (this.localBranchName) return this.localBranchName;
      if (this.branchName) return this.branchName;
      const user = this.$store.getters["getActiveUser"];
      if (user && user.branch && user.branch.name) return user.branch.name;
      if (user && user.userBranch && user.userBranch !== 'Merkez') return user.userBranch;
      return "";
    }
  },
  methods: {
    resetLocalData() {
      this.localOrderEntries = null;
      this.localTotalPrice = null;
      this.localTotalOriginPrice = null;
      this.localTotalDiscountPrice = null;
      this.localBillNo = null;
      this.localTableName = null;
      this.localActivePersonal = null;
      this.localBranchName = null;
      this.localCopyCount = null;
      this.localIsFinal = null;
      this.localTotalPayedPrice = null;
      this.localLeftPrice = null;
      this.localOrderPayments = null;
    },
    async printOrders(count = null, isFinal = null, forceSignalR = false, forceBrowser = false) {
      console.log("%c !!! [V23-PRINT-START] !!! ", "background: blue; color: white; font-size: 14px", {
         "localAra": this.localTotalOriginPrice,
         "localIndirim": this.localTotalDiscountPrice,
         "localOdenen": this.localTotalPayedPrice,
         "StoreID": this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].id : 'N/A'
      });

      if (count !== null) this.localCopyCount = parseInt(count) || 1;
      else if (this.printCopyCount) this.localCopyCount = parseInt(this.printCopyCount) || 1;
      
      if (isFinal !== null) this.localIsFinal = isFinal;

      // Eğer local veriler henüz set edilmemişse (prop tabanlı direkt yazdırma durumu)
      if (this.localTotalOriginPrice === null || this.localTotalOriginPrice === 0) {
          console.log("!!! [V23-DIAG] localTotalOriginPrice is empty, using props as fallback.");
          const entries = this.orderEntries || [];
          this.localOrderEntries = entries;
          
          const parseSafe = (val) => {
              if (typeof val === "number") return val;
              if (typeof val === "string") return parseFloat(val.replace(",", ".")) || 0;
              return parseFloat(val) || 0;
          };

          const calculatedOrigin = entries.reduce((sum, e) => {
              const p = parseSafe(e.originPrice || e.OriginPrice || e.price || e.Price || 0);
              const q = parseSafe(e.quantity || e.Quantity || 1);
              return sum + (p * q);
          }, 0);

          this.localTotalOriginPrice = parseFloat(this.totalOriginPrice || calculatedOrigin);
          this.localTotalDiscountPrice = parseFloat(this.totalDiscountPrice || 0);
          this.localTotalPayedPrice = (this.totalPrice !== undefined && this.totalPrice !== null && Number(this.totalPrice) > 0) 
                                      ? parseFloat(this.totalPrice) 
                                      : Math.max(0, this.localTotalOriginPrice - this.localTotalDiscountPrice);
          this.localTotalPrice = this.localTotalPayedPrice;
          this.localLeftPrice = 0;
      }

      const pSettings = JSON.parse(localStorage.getItem('posSettings') || '{}');
      
      // v87: Eğer bağlantı kopuksa ve SignalR zorlanıyorsa bir kez bağlanmayı dene
      if (forceSignalR && this.connection && this.connection.state !== 'Connected') {
         console.log("SignalR Connection lost. Attempting to restart...");
         try {
            await this.connection.start();
         } catch (e) {
            console.error("SignalR Restart Failed:", e);
         }
      }

      const isConnected = this.connection && this.connection.state === 'Connected';
      console.log(`Print Command: forceSignalR=${forceSignalR}, forceBrowser=${forceBrowser}, isConnected=${isConnected}`);

      // 1. OTOMATİK BASKI (Terminal / SignalR)
      if (forceSignalR || (!forceBrowser && pSettings.enable)) {
        if (isConnected) {
          try {
            const model = this.prepareModelForBackend();
            const copies = this.localCopyCount || 1;
            for (let i = 0; i < copies; i++) {
               await this.connection.invoke("PrintPayment", model);
            }
            console.log("[v118.V23] SignalR Otomatik Baskı Gönderildi.");
            
            // Eğer manuel baskı istenmemişse (forceBrowser=false), burada durabiliriz
            if (!forceBrowser) return;
          } catch (err) {
            console.error("SignalR Print Invoke Error:", err);
            this.$vs.notify({ title: 'Hata', text: 'Terminal uygulamasına veri gönderilemedi: ' + err.message, color: 'danger' });
          }
        } else if (forceSignalR) {
          this.$vs.notify({ 
            title: 'Bağlantı Sorunu', 
            text: 'Terminal uygulamasına bağlanılamadı. Otomatik baskı yapılamadı. Tarayıcı önizlemesi açılıyor...', 
            color: 'warning'
          });
          // Bağlantı yok ama kullanıcı forceSignalR demişse, fallback olarak browser'a devam etmesine izin veriyoruz
        }
      }

      // 2. MANUEL BASKI (Browser / PrintJS)
      try {
        console.log("[v118.V23] Browser Manuel Baskı Tetikleniyor...");
        this.$nextTick(() => {
          setTimeout(() => {
            printJS({ 
              showModal: false, 
              printable: this.printerId || 'printerDiv', 
              type: 'html', 
              style: PRINT_CSS,
              scanStyles: false
            });
          }, 500);
        });
      } catch (e) {
        console.error("Yazdırma hatası:", e);
      }
      
      // v84: Eğer SignalR bekleniyordu ama tarayıcıya düştüyse kullanıcıya küçük bir uyarı ver
      if (forceSignalR && (!this.connection || this.connection.state !== 'Connected')) {
         this.$vs.notify({
            title: 'Bilgi',
            text: 'Terminal Bağlantısı (SignalR) aktif değil. Tarayıcı önizlemesi kullanılıyor. Lütfen sayfayı (F5) yenileyin',
            color: 'warning',
            time: 5000
         });
      }
    },
    prepareModelForBackend() {
      // v95: En kararlÄ± yapÄ±. Store'daki orijinal nesneyi bozma.
      let cart = JSON.parse(JSON.stringify(this.$store.getters['selfservice/getCurrentCart'] || {}));
      
      if (this.localOrderEntries && this.localOrderEntries.length > 0) {
        cart.cartEntries = JSON.parse(JSON.stringify(this.localOrderEntries));
        cart.id = Number(this.localBillNo || this.billNo || cart.id || 0);
        cart.totalPrice = Number(this.localTotalPrice || cart.totalPrice || 0);
      }

      // v118.V22 [SIGNAL-R-STRICT]: KardeÅŸimizin iÅŸaretlediÄŸi alanlara gÃ¶re mÃ¼hÃ¼rle (TotalPrice->Ara, Promotion->Ä°ndirim, Net->Ã–denen).
      const totalGross = Number(this.localTotalOriginPrice !== null ? this.localTotalOriginPrice : (this.totalOriginPrice || cart.totalOriginPrice || cart.totalPrice || 0));
      const totalDiscount = Number(this.localTotalDiscountPrice !== null ? this.localTotalDiscountPrice : (this.totalDiscountPrice || cart.totalDiscountPrice || 0));
      const totalNet = Number(this.localTotalPayedPrice !== null ? this.localTotalPayedPrice : (this.totalPrice !== undefined ? this.totalPrice : (cart.totalPayedPrice || 0)));
      const finalLeftPrice = Number(this.localLeftPrice !== null ? this.localLeftPrice : (this.leftPrice !== undefined ? this.leftPrice : (totalGross - totalDiscount - totalNet)));

      cart.totalOriginPrice = totalGross; 
      cart.totalDiscountPrice = totalDiscount;
      cart.totalPayedPrice = totalNet; 
      cart.totalPrice = totalNet; 
      cart.leftPrice = finalLeftPrice;
      
      // v118.Beta-Final-5: Terminal App (C#) 'Price' alanÄ±nÄ± genellikle BÄ°RÄ°M FÄ°YAT olarak bekler.
      // Biz localData'da (L118.Beta-Final-3/4) SATIR TOPLAMI tutmaya baÅŸladÄ±k. 
      // Bu yÃ¼zden Terminal App'e gÃ¶nderirken BÃ–LME iÅŸlemini burada yapmalÄ±yÄ±z.
      const list = cart.cartEntries || [];
      list.forEach(e => {
        const qty = parseFloat(e.productQuantity || e.quantity || 1);
        if (qty > 0) {
           e.price = (parseFloat(e.price) || 0) / qty;
           if (e.originPrice) e.originPrice = (parseFloat(e.originPrice) || 0) / qty;
        }
      });
      
      // v105: EÄŸer final fiÅŸi ise isAdisyon = false olmalÄ± ki "Ã–denen Toplam" yazsÄ±n
      cart.isAdisyon = !(this.localIsFinal !== null ? this.localIsFinal : this.isFinal);
      
      cart.branchId = Number(cart.branchId || (this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.branch ? this.$store.state.AppActiveUser.branch.id : 0));
      cart.UserName = this.localActivePersonal || this.activePersonal || (this.$store.state.AppActiveUser ? this.$store.state.AppActiveUser.name : "Sistem");

      // Bind hatasÄ±na yol aÃ§abilecek 'entries' kÄ±smÄ±nÄ± temizle (Terminal App cartEntries kullanÄ±r)
      delete cart.entries;
      delete cart.Entries;

      // v118.Beta-Final-10: AGRESÄ°F Ä°ZOLASYON -> Her Ã¼rÃ¼n iÃ§in malzeme listesini sÄ±fÄ±rdan kur.
      list.forEach(entry => {
        entry.productName = this.cleanProductName(entry.productName || "");
        
        // 1. EkstralarÄ± filtrele ve kopyala (Referans izolasyonu iÃ§in _.cloneDeep)
        const rawExtras = _.cloneDeep(entry.extras || entry.Extras || []);
        const filteredExtras = [];
        rawExtras.forEach(ex => {
          const qty = parseFloat(ex.quantity || ex.Quantity || 0);
          const variants = ex.variants || ex.Variants || [];
          if (qty > 0 && variants.length === 0) {
            filteredExtras.push(ex);
          } else if (variants.length > 0) {
            const vFiltered = variants.filter(v => parseFloat(v.quantity || v.Quantity || 0) > 0);
            if (vFiltered.length > 0) {
              ex.variants = vFiltered;
              ex.Variants = vFiltered;
              filteredExtras.push(ex);
            }
          }
        });
        entry.extras = filteredExtras;
        entry.Extras = filteredExtras;

        // 2. ReÃ§ete AdÄ±mlarÄ±nÄ± filtrele ve kopyala (Referans izolasyonu iÃ§in _.cloneDeep)
        const sourceData = entry.recipe || entry.Recipe || entry;
        const rawSteps = _.cloneDeep(sourceData.steps || sourceData.Steps || sourceData.recipeSteps || sourceData.RecipeSteps || entry.steps || entry.Steps || []);
        
        const filteredSteps = Array.isArray(rawSteps) ? rawSteps.filter(
          (x) => x && (
            (x.isRemoved || x.IsRemoved || x.is_removed || x.is_Removed || ((x.isDefault || x.IsDefault) && !(x.selected || x.Selected))) 
            ||
            ((x.selected || x.Selected) && !(x.isDefault || x.IsDefault))
          )
        ).map(step => {
            const _isRemoved = !!(step.isRemoved || step.IsRemoved || step.is_removed || step.is_Removed || ((step.isDefault || step.IsDefault) && !(step.selected || step.Selected)));
            const rawMat = step.rawMaterial || step.RawMaterial || step.raw_material;
            const pName = step.productName || step.ProductName || (step.product && (step.product.name || step.product.Name));
            
            return {
              ...step,
              isRemoved: _isRemoved,
              name: (rawMat && (rawMat.name || rawMat.Name)) ? (rawMat.name || rawMat.Name) : 
                           (pName ? pName : (step.name || step.Name || "Malzeme"))
            };
        }) : [];

        // 3. Mevcut ReÃ§ete Nesnelerini temizle ve sadece filtreli olanlarÄ± ata
        if (entry.recipe) entry.recipe.steps = filteredSteps;
        if (entry.Recipe) entry.Recipe.Steps = filteredSteps;
        entry.steps = filteredSteps;
        entry.RecipeSteps = filteredSteps;
        entry.recipeSteps = filteredSteps;
      });

      return cart;
    },
    async fetchAndPrint(orderId, count = null, isFinal = null, expectedOrderNo = null, dbOrder = null, forceSignalR = false, forceBrowser = false) {
        this.resetLocalData();
        if (count !== null) this.localCopyCount = count;
        if (isFinal !== null) this.localIsFinal = isFinal;
        
        if (!orderId) {
          console.warn("fetchAndPrint: orderId is missing, using props for print.");
          this.$nextTick(() => { this.printOrders(null, null, forceSignalR, forceBrowser); });
          return;
        }

        this.isLoading = true;
        try {
            console.log("[v118.V22] Agresif DB Bekleme BaÅŸladÄ± (Max 10sn) - OrderID:", orderId);

            // [v118.V22] SipariÅŸ tamamlandÄ±ktan sonra DB'deki ana verilerin (Price/Promotion/Net) oturmasÄ±nÄ± bekle (6 deneme)
            for (let i = 0; i < 6; i++) {
                try {
                    // 1. EÄŸer elimizde dbOrder yoksa, OrderLogs'tan Ã§ekmeyi dene
                    if (!dbOrder) {
                        const bId = this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.branch ? this.$store.state.AppActiveUser.branch.id : null;
                        if (bId) {
                            const logResp = await getOrderLogs({ branch: { id: bId }, order: { id: orderId } });
                            const rawLogData = logResp.data || {};
                            let logs = [];
                            if (rawLogData.items && Array.isArray(rawLogData.items)) logs = rawLogData.items;
                            else if (rawLogData.data && Array.isArray(rawLogData.data)) logs = rawLogData.data;
                            else if (Array.isArray(rawLogData)) logs = rawLogData;

                            const found = logs.find(o => o.id == orderId);
                            if (found) {
                                dbOrder = found;
                                console.log(`[v118.V22] dbOrder found on attempt ${i+1}!`, found.id);
                            }
                        }
                    }

                    // 2. Kalemleri (Entries) çekmeyi dene
                    const response = await getOrderEntries(orderId);
                    const order = (response.data && response.data.data) ? response.data.data : response.data;
                    
                    if (order && (order.cartEntries || order.entries)) {
                        if (expectedOrderNo && order.orderNo && order.orderNo != expectedOrderNo) {
                             // OrderNo bazen gecikmeli güncelleniyor, mismatch varsa bekle
                             console.warn(`[v118.V22] OrderNo mismatch (${order.orderNo} != ${expectedOrderNo}). Retrying...`);
                        } else {
                             console.log(`[v118.V22] Order fetched from DB correctly on attempt ${i+1}!`, orderId);

                            // [v118.V20] Kesin finansallar: DB->Order verilerini (Price/Promotion/Net) üzerine mühürle
                            if (dbOrder) {
                                console.log("!!! [V23-DIAG] dbOrder RAW:", JSON.stringify(dbOrder));
                                order.totalPrice = (dbOrder.totalPrice !== undefined && dbOrder.totalPrice !== null) ? dbOrder.totalPrice : dbOrder.TotalPrice;
                                order.promotionPrice = (dbOrder.promotionPrice !== undefined && dbOrder.promotionPrice !== null) ? dbOrder.promotionPrice : dbOrder.PromotionPrice;
                                order.netPrice = (dbOrder.netPrice !== undefined && dbOrder.netPrice !== null) ? dbOrder.netPrice : dbOrder.NetPrice;
                                console.log("!!! [V23-DIAG] Mapped to order:", { 
                                    totalPrice: order.totalPrice, 
                                    promotionPrice: order.promotionPrice, 
                                    netPrice: order.netPrice 
                                });
                            }

                            this.setOrderAndPrint(order, null, true, forceSignalR, forceBrowser);
                            return; // Başarılı, mühürle ve çık.
                        }
                    }
                } catch(reqErr) {
                    console.warn(`[v118.V22] Attempt ${i+1} error:`, reqErr.message);
                }
                
                // Hâlâ başarılı olamadıysak 1.5 saniye bekle ve tekrar dene
                await new Promise(res => setTimeout(res, 1500));
            }
            
            console.error("[v118.V22] DB'den güncel veri 6 denemeye rağmen alınamadı! Hatalı fiş basmamak için SNAPSHOT kullanılacak.");
            this.$nextTick(() => { this.printOrders(null, true, forceSignalR, forceBrowser); });
        } catch (error) {
            console.error("fetchAndPrint error:", error);
            this.$nextTick(() => { this.printOrders(null, true, forceSignalR, forceBrowser); });
        } finally {
            this.isLoading = false;
        }
    },
    async handleDBSuccessPrint(sid, branchId) {
        if (!sid) {
           console.error("[v118.V24] SID is missing, cannot perform authoritative print.");
           return;
        }
        this.isLoading = true;
        try {
            console.log("%c [v118.V24] AUTOMATIC/MANUAL AUTH-PRINT TRIGGERED ", "background: indigo; color: white", { sid, branchId });
            
            // 1. [DB-SAFETY]: DB'ye yazılma payı için otomatik tetiklemelerde 500ms bekleyelim (Race condition prevention)
            await new Promise(r => setTimeout(r, 500));

            // 2. Yeni Backend API (SADECE SID İLE ÇEK)
            try {
               const fastRes = await getOrderBySID(sid);
               const fastOrder = (fastRes.data && fastRes.data.data) ? fastRes.data.data : (fastRes.data || fastRes);
               if (fastOrder && fastOrder.id) {
                  console.log("[v118.V25] BACKEND-MATCH! Sipariş SID ile doğrudan bulundu.");
                  
                  // v118.V25: Authoritative Kitchen Print Trigger (Adisyon Modu: AKTİF) - [SIGNAL-R DEVRE DIŞI]
                  /*
                  triggerKitchenPrintBySID(sid, "Mutfak", fastOrder.tableName || fastOrder.Name || this.localTableName || this.tableName, true)
                    .catch(e => console.warn("Background Kitchen Print (Adisyon) fail:", e));
                  */

                  // v118.V29: ÖNEMLİ -> Sipariş tamamlanınca OTOMATİK SignalR tetiklenmesin, sadece Browser Print açılsın.
                  this.setOrderAndPrint(fastOrder, null, true, false, true);

                  // v135: Mark as printed in the backend (Authoritative for auto-prints)
                  markAdisyonPrinted(sid).catch(e => console.warn("Auto-markAdisyonPrinted fail:", e));
                  return;
               }
            } catch (e) {
               console.warn("[v118.V24] Fast API Henüz Bulamadı. Fallback Loop Başlıyor...");
            }

            // 3. Fallback: Mevcut Loop (DB Gecikmesi için)
            for (let i = 0; i < 7; i++) {
               const response = await getOrderLogs({ 
                  branchTableUId: sid,
                  branch: { id: branchId }, 
                  pageSize: 15,
                  sortBy: "Id",
                  sortDirection: "desc"
               });
               
               const rawData = response.data || {};
               let orders = [];
               if (rawData.items && Array.isArray(rawData.items)) orders = rawData.items;
               else if (rawData.data && Array.isArray(rawData.data)) orders = rawData.data;
               else if (Array.isArray(rawData)) orders = rawData;

               console.log("!!! [V23-DIAG-SID-LOGS] Attempt:", i+1, "Orders Count:", orders.length);
               
               // v118.V23 [DEEP-MATCH]: Liste içinde description/SID gelmiyorsa, adayları tek tek sorgula!
               if (Array.isArray(orders)) {
                   for (let o of orders) {
                       const candidateId = o.id || o.Id;
                       if (!candidateId) continue;

                       // 1. YÃ¼zeysel Kontrol
                       const oId = o.branchTableUid || o.BranchTableUid || o.branchTableUId || o.BranchTableUId;
                       if (oId === sid) {
                           console.log(`[v118.V23] SID Match Found in List! ID: ${candidateId}`);
                           await this.fetchAndPrint(candidateId, null, true, null, o, false, true); // forceSignalR = false, forceBrowser = true
                            markAdisyonPrinted(sid).catch(e => {});
                           return;
                       }

                       // 2. Derin Kontrol (AdayÄ± tek sorgula)
                       try {
                           const dRes = await getOrderEntries(candidateId);
                           const detail = (dRes.data && dRes.data.data) ? dRes.data.data : (dRes.data || dRes);
                           const dId = detail.branchTableUid || detail.BranchTableUid || detail.branchTableUId || detail.BranchTableUId;
                           const dDesc = detail.description || detail.Description || "";

                           if (dId === sid || (dDesc && dDesc.includes(`[SID:${sid}]`))) {
                               console.log(`[v118.V23] SID Deep Match Found! ID: ${candidateId}`);
                               await this.fetchAndPrint(candidateId, null, true, null, detail, false, true); // forceSignalR = false, forceBrowser = true
                                markAdisyonPrinted(sid).catch(e => {});
                               return;
                           }
                       } catch (e) {
                           console.warn(`[v118.V23] Deep Check Error for ${candidateId}:`, e.message);
                       }
                   }
               }
               
               console.warn(`[v118.V22] SID henüz DB'ye düşmedi. Attempt ${i+1}/6, 1.5sn bekleniyor...`);
               await new Promise(res => setTimeout(res, 1500));
            }
            
            console.error("[v118.V22] SID bulunamadı! Mevcut sepet verisine dönülüyor.");
            this.$nextTick(() => { this.printOrders(); });

        } catch (error) {
           console.error("fetchAndPrintBySID error:", error);
           this.$nextTick(() => { this.printOrders(); });
        } finally {
            this.isLoading = false;
        }
    },
     setOrderAndPrint(order, count = null, isFinal = null, forceSignalR = false, forceBrowser = false) {
        this.resetLocalData();
        if (count !== null) this.localCopyCount = parseInt(count) || 1;
        if (isFinal !== null) this.localIsFinal = isFinal;
        if (!order) {

          this.$nextTick(() => { this.printOrders(null, null, forceSignalR, forceBrowser); });
          return;
        }
       
         const pOrder = order || {};
         const entries = pOrder.cartEntries || pOrder.entries || pOrder.Entries || [];
        
        // GÃ¼venlik: EÄŸer Ã§ekilen sipariÅŸte hiÃ§ Ã¼rÃ¼n yoksa, prop'taki (snapshot) veriyi bozmamak iÃ§in Ã¼zerine yazma!
        if (entries.length === 0 && !pOrder.totalPrice && !pOrder.TotalPrice) {
           console.warn("setOrderAndPrint: Fetched order has no entries or totals, using props.");
           this.$nextTick(() => { this.printOrders(); });
           return;
        }

        this.localOrderEntries = entries;

        // v23.5 [STRICT-MAPPING]: Backend'den (DB'den) gelen ham verileri Ã¶nceliklendir.
        let dTotalPrice = (pOrder.totalPrice !== undefined && pOrder.totalPrice !== null) ? pOrder.totalPrice : (pOrder.TotalPrice !== undefined ? pOrder.TotalPrice : null);
        let dPromotionPrice = (pOrder.promotionPrice !== undefined && pOrder.promotionPrice !== null) ? pOrder.promotionPrice : (pOrder.PromotionPrice !== undefined ? pOrder.PromotionPrice : null);
        let dNetPrice = (pOrder.netPrice !== undefined && pOrder.netPrice !== null) ? pOrder.netPrice : (pOrder.NetPrice !== undefined ? pOrder.NetPrice : null);

        // v118.V26: Force re-calculation if totals are zero but entries exist
        const parseSafe = (val) => {
            if (typeof val === "number") return val;
            if (typeof val === "string") return parseFloat(val.replace(",", ".")) || 0;
            return parseFloat(val) || 0;
        };

        if ((!dTotalPrice || dTotalPrice == 0) && entries.length > 0) {
            dTotalPrice = entries.reduce((acc, curr) => {
                const p = parseSafe(curr.originPrice || curr.OriginPrice || curr.price || curr.Price || 0);
                const q = parseSafe(curr.quantity || curr.Quantity || 1);
                return acc + (p * q);
            }, 0);
        }
        if ((dPromotionPrice === null || dPromotionPrice === undefined || dPromotionPrice === 0) && entries.length > 0) {
            dPromotionPrice = entries.reduce((acc, curr) => {
                const o = parseSafe(curr.originPrice || curr.OriginPrice || curr.price || curr.Price || 0);
                const p = parseSafe(curr.price || curr.Price || 0);
                const q = parseSafe(curr.quantity || curr.Quantity || 1);
                return acc + ((o > p ? (o - p) : 0) * q);
            }, 0);
        }

        this.localTotalOriginPrice = parseFloat(dTotalPrice) || 0;
        this.localTotalDiscountPrice = parseFloat(dPromotionPrice) || 0;
        
        const parsedNet = parseFloat(dNetPrice);
        if (dNetPrice !== null && !isNaN(parsedNet)) {
            this.localTotalPayedPrice = parsedNet;
        } else {
            // EÄŸer net fiyat yoksa, Ã¶denen toplam olarak (Genel Toplam - Ä°ndirim) gÃ¶ster
            this.localTotalPayedPrice = Math.max(0, this.localTotalOriginPrice - this.localTotalDiscountPrice);
        }
        
        this.localTotalPrice = this.localTotalPayedPrice;
        this.localLeftPrice = 0;
        
        this.localBillNo = pOrder.orderNo || pOrder.billNo || pOrder.bill_no || pOrder.id || pOrder.Id || this.billNo;
        this.localTableName = pOrder.tableName || pOrder.TableName || pOrder.name || pOrder.Name || this.tableName;
        this.localActivePersonal = pOrder.userName || pOrder.UserName || pOrder.ActivePersonal || pOrder.activePersonal || pOrder.ActivePersonel || pOrder.activePersonel || this.activePersonal;
        this.localBranchName = pOrder.branchName || (pOrder.branch && pOrder.branch.name) || (pOrder.Branch && pOrder.Branch.Name) || this.branchName;
        
        console.log("%c [Printer v118.V26] Final Mapped Data: ", "background: green; color: white", {
            origin: this.localTotalOriginPrice,
            discount: this.localTotalDiscountPrice,
            payed: this.localTotalPayedPrice,
            person: this.localActivePersonal
        });
       
       this.$nextTick(() => {
         this.printOrders(null, null, forceSignalR, forceBrowser);
       });
    },
    formatTimeForPrint(entry) {
      try {
        const totalHours = entry.totalHour || entry.TotalHour || entry.TimeHour || 0;
        const startStr = entry.lastStartTime || entry.LastStartTime || entry.startTime || entry.StartTime;
        const stopStr = entry.lastStopTime || entry.LastStopTime || entry.endTime || entry.EndTime;

        if (totalHours > 0) {
          return Math.ceil(totalHours * 60) + ' dk';
        }

        if (startStr && stopStr) {
          const start = new Date(startStr);
          const stop = new Date(stopStr);
          if (!isNaN(start) && !isNaN(stop)) {
            const diffMs = Math.abs(stop - start);
            const diffMin = Math.ceil(diffMs / (1000 * 60));
            return diffMin + ' dk';
          }
        }
        return '0 dk';
      } catch (e) { return '0 dk'; }
    },
    cleanProductName(name) {
      if (!name) return '';
      let n = name.replace(/\s\d{2}:\d{2}$/, '');
      let separator = n.includes('->') ? '->' : (n.includes('>') ? '>' : null);
      
      if (separator) {
        const parts = n.split(separator).map(s => s.trim());
        const main = parts[0];
        // Filter out 'Adet' or parts that just repeat the main product name
        const filteredParts = parts.filter((part, index) => {
          if (index === 0) return true;
          const p = part.toLowerCase();
          return p !== 'adet' && !main.toLowerCase().includes(p) && !p.includes(main.toLowerCase());
        });
        return filteredParts.join('->');
      }
      return n;
    },
    shortName(userName) {
      if (!userName) return '';
      // Ä°sim Ã§ok uzunsa Bilgi sÃ¼tununu bozmasÄ±n diye hafifÃ§e kÄ±saltÄ±yoruz
      return userName.substring(0, 12).trim();
    },
    shortDate(timeStr, createdDateStr) {
      try {
        const sources = [createdDateStr, timeStr].filter(Boolean);
        for (const src of sources) {
          // ISO format (2026-03-06T10:47:08.839812Z) kontrolÃ¼ - Saat kaymasÄ±nÄ± Ã¶nlemek iÃ§in manuel parÃ§alama
          if (typeof src === 'string' && src.includes('T')) {
            try {
              const [datePart, timePart] = src.split('T');
              const dParts = datePart.split('-'); // 2026, 03, 06
              const tParts = timePart.split(':'); // 10, 47, 08...
              if (dParts.length >= 3 && tParts.length >= 2) {
                return `${dParts[2].padStart(2, '0')}/${dParts[1].padStart(2, '0')} ${tParts[0].padStart(2, '0')}:${tParts[1].padStart(2, '0')}`;
              }
            } catch (e) {}
          }

          const d = new Date(src);
          if (!isNaN(d.getTime()) && d.getFullYear() > 2000) {
            const day   = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const hh    = String(d.getHours()).padStart(2, '0');
            const mm    = String(d.getMinutes()).padStart(2, '0');
            return `${day}/${month} ${hh}:${mm}`;
          }
        }
        if (timeStr && /^\d{1,2}:\d{2}/.test(timeStr)) {
          const now = new Date();
          const day   = String(now.getDate()).padStart(2, '0');
          const month = String(now.getMonth() + 1).padStart(2, '0');
          return `${day}/${month} ${timeStr.substring(0, 5)}`;
        }
      } catch (e) {}
      return '';
    }
  }
}
</script>

<style>
/* Ã–NÄ°ZLEME EKRANI Ä°Ã‡Ä°N CSS (Birebir PRINT_CSS ile senkronize edildi) */
.pr-container { 
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; 
  width: 80mm; 
  max-width: 100%;
  margin: 20px auto; 
  padding: 10pt 6pt; 
  box-sizing: border-box; 
  color: #000; 
  background: #fff;
  border: 1px solid #ddd; 
  box-shadow: 0 4px 12px rgba(0,0,0,0.15); 
}

.pr-header { text-align: center; margin-bottom: 8pt; }
.pr-branch { font-size: 12pt !important; font-weight: 900; margin-bottom: 2pt; text-transform: uppercase; letter-spacing: 0.5pt; }
.pr-sub-branch { font-size: 10pt !important; font-weight: bold; margin-bottom: 4pt; text-transform: uppercase; }
.pr-meta { font-size: 9pt !important; line-height: 1.5; color: #000; }
.pr-meta-user { margin-top: 2pt; font-size: 9pt !important; color: #000; }

.pr-sep { border: 0; border-top: 1.5px dashed #000; margin: 4pt 0; display: block; }
.pr-sep-thick { border-top: 2px solid #000 !important; margin-top: 2pt; margin-bottom: 4pt; }
.pr-sep-thin  { border-top: 1px solid #000 !important; margin-top: 4pt; margin-bottom: 4pt; }

.pr-tbl { width: 100%; border-collapse: collapse; table-layout: fixed; margin-bottom: 4pt; }
.pr-c-name  { width: 58%; }
.pr-c-qty   { width: 17%; }
.pr-c-price { width: 25%; }

.pr-al { text-align: left; }
.pr-ac { text-align: center; }
.pr-ar { text-align: right; }

.pr-th { font-size: 9pt !important; font-weight: bold; padding: 2pt 0 4pt; border-bottom: 1.5px solid #000; }
.pr-td { vertical-align: middle; padding: 5pt 0; word-break: break-word; }

.pr-item-row { border-bottom: 1px dashed #bbb; }
.pr-item-row:last-child { border-bottom: none; }

.pr-product-name { font-size: 9.5pt !important; font-weight: bold; display: block; }
.pr-block { display: block; }
.pr-sub  { font-size: 7.5pt !important; color: #000; padding-left: 3pt; margin-top: 1.5pt; }
.pr-note { font-size: 7.5pt !important; font-style: italic; color: #000; margin-top: 1.5pt; font-weight: bold; }

.pr-qty-badge { font-weight: bold; font-size: 9.5pt !important; }
.pr-price-cell { font-weight: 900; font-size: 10pt !important; white-space: nowrap; }

.pr-act-txt { font-size: 8pt !important; display: block; line-height: 1.3; color: #000; text-align: right; }
.pr-act-name { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: bold; }
.pr-act-date { white-space: nowrap; color: #000; }

.pr-ftr-tbl { width: 100%; border-collapse: collapse; }
.pr-ftr-lbl { font-size: 10pt !important; font-weight: bold; text-align: left; padding: 2pt 0; white-space: nowrap; width: 50%; }
.pr-ftr-val { font-size: 10pt !important; font-weight: bold; text-align: right; padding: 2pt 0; }
.pr-ftr-net { border-top: 2px solid #000; }
.pr-ftr-net .pr-ftr-lbl { font-size: 12pt !important; font-weight: 900; padding-top: 4pt; }
.pr-ftr-net .pr-ftr-val { font-size: 13pt !important; font-weight: 900; padding-top: 4pt; }
.pr-discount { color: #000; }

.pr-thanks  { text-align: center; font-size: 9pt !important; padding: 6pt 0 2pt; line-height: 1.6; font-weight: bold; }
.pr-line-through { text-decoration: line-through !important; }
</style>
